import { render, staticRenderFns } from "./input-3-input-with-update-button.vue?vue&type=template&id=8f80e0fe&scoped=true&"
import script from "./input-3-input-with-update-button.vue?vue&type=script&lang=ts&"
export * from "./input-3-input-with-update-button.vue?vue&type=script&lang=ts&"
import style0 from "./input-3-input-with-update-button.vue?vue&type=style&index=0&id=8f80e0fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80e0fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VSelect,VTextField,VTextarea})
